/**
 * Fetch Filter section for the SFTP Push tab. The resubmit cron fetches rows
 * matching these conditions. Backed by the shared QueryBuilder bound to the
 * SFTP-push field config.
 */
import QueryBuilder from "../../../../../components/queryBuilder/QueryBuilder";
import { QueryBuilderConfig, QueryGroup } from "../../../../../data-model/queryBuilder";

interface FetchFilterSectionProps {
  resetKey: number;
  value: QueryGroup;
  onChange: (value: QueryGroup) => void;
  config: QueryBuilderConfig;
}

const FetchFilterSection = ({
  resetKey,
  value,
  onChange,
  config,
}: FetchFilterSectionProps) => (
  <div className="flex flex-col gap-3 rounded-lg border border-primaryGray-16 p-4">
    <div className="text-sm font-semibold text-primaryGray-1">Fetch Filter</div>
    <div className="text-tiny text-primaryGray-8">
      Rows matching these conditions are pulled into the resubmit file.
    </div>
    <QueryBuilder
      key={`fetch-filter-${resetKey}`}
      value={value}
      onChange={onChange}
      config={config}
    />
  </div>
);

export default FetchFilterSection;
